import { GenreMap } from 'models'

export const transformGenre = (genre: number): string => {
  return GenreMap.get(genre) || ''
}
